import api from "./api";

const StorageService = {
  setActiveCompany: (company) => {
    localStorage.setItem("selectedCompany", company.companyName);
    localStorage.setItem("selectedCompanyId", company.id);
  },
  activeCompany: () => {
    return {
      companyName: localStorage.getItem("selectedCompany"),
      companyId: localStorage.getItem("selectedCompanyId")
    }
  },
  setLoginData: (user) => {
    localStorage.setItem("employeeId", user.employeeId);
    localStorage.setItem("firstName", user.firstName);
    localStorage.setItem("lastName", user.lastName);
    localStorage.setItem("empCompanyId", user.companyId);
    localStorage.setItem("empRoleId", user.roleId);
    localStorage.setItem("empRoleName", user.roleName);
    localStorage.setItem("empEmailId", user.emailId);
    localStorage.setItem("empLoginId", user.loginId);
  },
  loginData: () => {
    const employeeId = localStorage.getItem("employeeId");
    if (!employeeId) return null;
    return {
      employeeId,
      firstName: localStorage.getItem("firstName"),
      lastName: localStorage.getItem("lastName"),
      companyId: localStorage.getItem("empCompanyId"),
      roleId: localStorage.getItem("empRoleId"),
      roleName: localStorage.getItem("empRoleName"),
      emailId: localStorage.getItem("empEmailId"),
      loginId: localStorage.getItem("empLoginId")
    }
  }
};

export default StorageService;
